export const OPTIMISTIC_UPDATE_PREFIX = 'optimisticUpdate';
